import React, { useCallback, useState } from 'react'
import { WhiteBox } from '@/components/Layout'
import { BsrsGrid, Column } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import moment from 'moment'
import { openConfirmDialog, openErrorDialog } from '@/utils/dialogHelpers'
import { Button } from '@/components/button'
import { dialogTypes } from '@/dialogs'
import { TdActions } from '@/components/tdActions'
import Resx from '@/components/Resx'
import { useDialog } from '@/hooks/useDialog'

const ColumnBindings = React.memo(() => {
  const { localize } = useLocalization()
  const [lastReloadedAt, setLastReloadedAt] = useState(moment())
  const openDialog = useDialog()

  const onItemEdited = useCallback(item => {
    context.api.institutionReportGroupService.updateColumnBinding(item)
      .then(() => setLastReloadedAt(moment()))
      .catch(() => openErrorDialog())
  }, [])

  const onItemAdd = useCallback(() => {
    openDialog({
      dialogType: dialogTypes.addColumnBinding,
      onAction: (item) => context.api.institutionReportGroupService.addColumnBinding(item)
        .then(() => setLastReloadedAt(moment()))
        .catch(() => openErrorDialog())
    })
  }, [openDialog])

  const DeleteButton = ({ dataItem }) => {
    const deleteItem = useCallback(() => {
      openConfirmDialog({
        customTitle: 'Reporting.DeleteBindingTitle',
        customConfirmText: 'Reporting.DeleteBinding',
        onAction: () => context.api.institutionReportGroupService.deleteColumnBinding(dataItem.id)
          .then(() => setLastReloadedAt(moment()))
          .catch(() => openErrorDialog())
      })
    }, [dataItem.id])

    return <TdActions>
      <Button iconOnly icon='trash' onClick={deleteItem} />
    </TdActions>
  }

  return <React.Fragment>
    <WhiteBox header='Reporting.ColumnBindings' buttons={
      <Button icon='plus' className='btn btn-success' onClick={onItemAdd}><Resx name='Reporting.AddColumnBinding' /></Button>
    }>
      <BsrsGrid
        dataSource={context.api.institutionReportGroupService.getAllColumnBindings}
        lastReloadedAt={lastReloadedAt}
        onItemEdited={onItemEdited}
      >
        <Column field='id' title={localize('Common.Id')} editable={false} />
        <Column field='reportCode' title={localize('Reporting.ReportCode')} editable />
        <Column field='treeCode' title={localize('Reporting.TreeCode')} editable />
        <Column field='propertyName' title={localize('Reporting.PropertyName')} editable />
        <Column cell={DeleteButton} filterable={false} editable={false} />
      </BsrsGrid>
    </WhiteBox>
  </React.Fragment>
})

export { ColumnBindings }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/icbsReportAdministration/columnBindings.js